import {
  PlacementWarningDialog,
  type PlacementWarningDialogProps,
} from '@/components/app/placement/placement-warning-dialog'

export function PhotoSizeWarningAlert(props: PlacementWarningDialogProps) {
  return (
    <PlacementWarningDialog
      {...props}
      tone="warning"
      title="Photo Size"
      message="This photo is too small. Continuing will place it in a new frame."
      continueLabel="Continue"
    />
  )
}
